import React from 'react';
import PropTypes from 'prop-types';
// import JSXStyle from 'styled-jsx/style';

import styles from './article.module.css';

import { ArticleContext } from './Context';

import { StyledImage } from './components/Image';
import { StyledAdvert } from './components/Advert';
import { StyledSpacer } from './components/Spacer';
import { StyledVideo } from './components/Video';
import { StyledAudio } from './components/Audio';
import { StyledDivider } from './components/Divider';
import { StyledTwitterTimeline } from './components/Twitter';
import { StyledText } from './components/Text';
import { Canvas } from './Canvas';
import { StyledInfogram } from './components/Infogram';
import { StyledColumns } from './components/Columns';
import { StyledGallery } from './components/Gallery';
import { StyledCustom } from './components/Custom';
import { StyledButton } from './components/Button';
import { Anchor } from './components/Anchor';
import { StyledTabs } from './components/Tabs';

import { Lightbox } from './lightbox/Lightbox';
import { AppContext } from '../../../services/AppContext';

import { CSS } from './CSS';

// import { StyledMap } from './components/Map';

const breakpoints = {
	mobile: 767,
	tablet: 1024,
};

export class Article extends React.Component {
	static contextType = AppContext;
	ref = React.createRef();

	state = {
		width: null,
		height: null,
		device: 'mobile',
		StyleID: 0,
		isLightboxDisplayed: false,
		customCSS: [],
		sassQueue: [],
	};

	componentDidMount() {
		const { id, styles, style } = this.props;

		const element = this.ref.current;
		const width = element.clientWidth;
		const device =
			width < breakpoints.mobile + 1
				? 'mobile'
				: width < breakpoints.tablet
				? 'tablet'
				: 'desktop';

		const css = new CSS(
			id,
			new Map(styles),
			clone(style),
			this.onCustomCSS
		);

		this.setState({
			height: element.clientHeight,
			device,
		});

		const isVideoAdd = this.isVideoAdd();

		css.build().then((cssContent) => {
			if (isVideoAdd) {
				cssContent =
					`
				@media screen and (min-width: 768px) {
					.article-${id} video {
						height: calc(100vh - var(--navbar-height)) !important;
					}
				}
				
				@media screen and (max-width: 767px) {
					.article-${id} > .canvas > :first-child,
					.article-${id} .video,
					.article-${id} .video a,
					.article-${id} .video video {
						height: 100%;
					}
				}
				` + cssContent;
			}
			this.setState({
				css: cssContent,
			});
			setTimeout(() => {
				this.setState({
					width,
				});
			}, 500);
		});

		// const observer = new MutationObserver(this.onResize);
		/*if(ResizeObserver) {
			try {
				const observer = new ResizeObserver(this.onResize);
				observer.observe(element, {
					attributes: true,
					attributeOldValue: true,
					attributeFilter: ['style'],
				});
			} catch(e) {
				console.log(`Observer doesn't exist, but the error was catched`);
				console.error(e);
			}
			
		}*/
		element.addEventListener('resize', this.resizeListener);

		// FIX ME Remove this to enable custom css
		// Is breaking in memory
		// setTimeout(this.processSass, this.props.index * 1500);
	}

	isVideoAdd() {
		const { components } = this.props;
		const videoComponents = components.filter(
			(c) => c.component === 'video'
		);
		return components.length === videoComponents.length;
	}

	onLightboxTargetClick = ({ id, resource, target }) => {
		if (this.props.onLightboxTargetClick) {
			this.props.onLightboxTargetClick({
				id,
				resource,
				target,
			});
		}
	};

	onCustomCSS = (scss) => {
		const { sassQueue } = this.state;
		sassQueue.push(scss);
		this.setState({
			sassQueue,
		});
	};

	processSass = () => {
		const interval = setInterval(this.onIntervalSass, 1000);
		this.setState({
			interval,
		});
	};

	onIntervalSass = () => {
		const { sassQueue, interval, customCSS } = this.state;
		if (!sassQueue.length) {
			clearInterval(interval);
			return;
		}

		const scss = sassQueue.shift();
		this.setState({
			sassQueue,
		});
		// eslint-disable-next-line no-undef
		const sass = new Sass();
		sass.compile(scss, (result) => {
			if (result.text) {
				customCSS.push(result.text);
				this.setState({
					customCSS,
				});
			}
		});
	};

	componentDidUpdate(_, prevState) {
		const { onLightboxMode } = this.props;
		const { isLightboxDisplayed } = this.state;
		if (prevState.isLightboxDisplayed !== isLightboxDisplayed) {
			if (onLightboxMode) {
				onLightboxMode(isLightboxDisplayed);
			}
		}
	}

	onResize = (mutations) => {
		const el = mutations[0].target;
		const w = el.clientWidth;
		const h = el.clientHeight;

		const isChange = mutations
			.map((m) => `${m.oldValue}`)
			.some(
				(prev) =>
					prev.indexOf(`width: ${w}px`) === -1 ||
					prev.indexOf(`height: ${h}px`) === -1
			);

		if (!isChange) {
			return;
		}
		const event = new CustomEvent('resize', {
			detail: { width: w, height: h },
		});
		el.dispatchEvent(event);
	};

	resizeListener = (e) => {
		const { width, height } = e.detail;
		const device =
			width < breakpoints.mobile + 1
				? 'mobile'
				: width < breakpoints.tablet
				? 'tablet'
				: 'desktop';
		this.setState({
			width,
			height,
			device,
		});
	};

	byDevice = ({ devices }) => {
		const { device } = this.state;
		if (
			(devices.phone === 'off' && device === 'mobile') ||
			(devices.tablet === 'off' && device === 'tablet') ||
			(devices.desktop === 'off' && device === 'desktop')
		) {
			return false;
		}

		return true;
	};

	byComponent = (component, i) => {
		switch (component.component) {
			case 'headline':
			case 'title':
			case 'subtitle':
			case 'intro':
			case 'body':
			case 'crosshead':
			case 'byline':
			case 'blockquote':
			case 'text1':
			case 'text2':
			case 'text3':
			case 'text4':
			case 'text5':
			case 'text6':
			case 'text7':
			case 'text8':
			case 'text9':
			case 'text10':
			case 'text11':
			case 'text12':
			case 'text13':
			case 'text14':
			case 'text15':
			case 'text16':
			case 'text17':
			case 'text18':
			case 'text19':
			case 'text20':
			case 'text21':
			case 'text22':
			case 'text23':
			case 'text24':
			case 'text25':
			case 'text26':
			case 'text27':
			case 'text28':
			case 'text29':
			case 'text30':
			case 'text31':
			case 'text32':
			case 'text33':
			case 'text34':
			case 'text35':
			case 'text36':
			case 'text37':
			case 'text38':
			case 'text39':
			case 'text40':
			case 'footer':
				return <StyledText key={i} {...component} />;
			case 'image':
				return <StyledImage key={i} {...component} />;
			case 'tabs':
				return <StyledTabs key={i} {...component} />;
			case 'advert':
				return <StyledAdvert key={i} {...component} />;
			case 'infogram':
				return <StyledInfogram key={i} {...component} />;
			case 'map':
				return null;
			// return <StyledMap key={i}  {...component}/>;
			case 'spacer':
				return <StyledSpacer key={i} {...component} />;
			case 'button':
				return <StyledButton key={i} {...component} />;
			case 'anchor':
				return <Anchor key={i} {...component} />;
			case 'audio':
				return <StyledAudio key={i} {...component} />;
			case 'video':
				return <StyledVideo key={i} {...component} />;
			case 'twitter':
				return <StyledTwitterTimeline key={i} {...component} />;
			case 'divider':
				return <StyledDivider key={i} {...component} />;
			case 'columns':
				return <StyledColumns key={component.id} {...component} />;
			case 'gallery':
				if (component['control-speed']) {
					component.control_speed = component['control-speed'];
				}
				return <StyledGallery key={i} {...component} />;
			case 'custom':
				return <StyledCustom key={i} {...component} />;
			default:
				return null;
		}
	};

	componentWillUnmount() {
		const element = this.ref.current;
		element.removeEventListener('resize', this.resizeListener);
	}

	onLightboxClick = ({ id }) => {
		console.log(`I CLICK LIGHTBOX: ${id}`);
		this.setState({ isLightboxDisplayed: true, lightboxId: id });
	};

	onEventSend = ({ event, data }) => {
		console.debug(`Event: "${event}"`);
		const { tracking } = this.context;

		const { url, componentId, componentType } = data;
		if (event === 'external' && tracking && url) {
			if (tracking) {
				tracking.external({
					url: url,
					articleId: this.props.id,
					componentId,
					componentType,
				});
			}
		}
	};

	render() {
		let {
			id,
			components,
			lang,
			fontSize,
			style,
			index,
			isVoid,
			isTouchDevice,
			textDirection,
			ArticleID,
		} = this.props;

		const { width, css, isLightboxDisplayed, lightboxId, customCSS } =
			this.state;
		let device =
			width < 767 ? 'mobile' : width < 1024 ? 'tablet' : 'desktop';

		const className = [styles['article'], `article-${id}`];
		className.push(device !== 'mobile' ? device : '');

		if (device === 'desktop' && !isTouchDevice) {
			className.push('swiper-no-swiping');
		}

		if (isVoid) {
			components = [];
		}

		const renderComponents = JSON.parse(JSON.stringify(components));

		return (
			<ArticleContext.Provider
				value={{
					id,
					device,
					width,
					isSelected: this.props.isSelected,
					styles: this.props.styles,
					style: clone(this.props.styles.get(style)),
					lang: lang ? lang : 'en',
					onLightboxClick: this.onLightboxClick,
					onLightboxTargetClick: this.onLightboxTargetClick,
					onEventSend: this.onEventSend,
				}}
			>
				<article
					id={`article-${id}`}
					data-article-id={ArticleID}
					data-style-id={style}
					dir={
						textDirection && textDirection.toLowerCase() === 'rtl'
							? 'rtl'
							: 'ltr'
					}
					ref={this.ref}
					data-index={index !== null ? index : null}
					style={{ fontSize: `${fontSize}%`, opacity: width ? 1 : 0 }}
					className={className.join(' ')}
				>
					<Canvas
						isAd={
							components.filter((c) => c.component === 'advert')
								.length > 0
						}
					>
						{renderComponents
							.filter(this.byDevice)
							.map(this.byComponent)
							.filter((i) => !!i)}
					</Canvas>
					{css ? <style>{css}</style> : null}
					{customCSS.length ? (
						<style>{customCSS.join('\n')}</style>
					) : null}
					<Lightbox
						display={isLightboxDisplayed}
						selected={lightboxId}
						components={renderComponents}
						onClose={() => {
							this.setState({ isLightboxDisplayed: false });
						}}
					/>
				</article>
			</ArticleContext.Provider>
		);
	}
}

function clone(obj) {
	if (structuredClone) {
		return structuredClone(obj);
	}
	return JSON.parse(JSON.stringify(obj));
}

Article.propTypes = {
	id: PropTypes.string,
	ArticleID: PropTypes.string,
	style: PropTypes.string,
	index: PropTypes.number,
	name: PropTypes.object,
	lightbox: PropTypes.bool,
	styles: PropTypes.instanceOf(Map),
	components: PropTypes.array,
	lang: PropTypes.string,
	fontSize: PropTypes.number,
	isVoid: PropTypes.bool,
	isTouchDevice: PropTypes.bool,
	onLightboxMode: PropTypes.any,
	onLightboxTargetClick: PropTypes.any,
	ref: PropTypes.any,
	textDirection: PropTypes.any,
	isSelected: PropTypes.bool,
};

Article.defaultProps = {
	color: '#ffffff',
	backgroundColor: '#ffffff',
	paddingTop: 0,
	paddingBottom: 0,
	spacingUnit: 'px',
	textDirection: 'ltr',
	fontSize: 62.5,
	horizontalPadding: 0,
	lang: 'en',
	styles: new Map(),
	components: [],
	isVoid: false,
	isSelected: false,
};
